import type { SketchControlsState } from './sketch-controls-slice';
import { loadFromCookie } from './sketch-controls-slice';

import type { AppDispatch, GetRootState } from 'js/src/libs/RootState';
import Cookies from 'js-cookie';

const COOKIE_NAME = 'sketch_controls';
const COOKIE_EXPIRES_DAYS = 365; // 1 year

// Cookies written before a field existed simply lack it, so every field is
// optional on the way back in.
export type SketchControlsCookieData = Partial<SketchControlsState>;

export function saveSketchControlsToCookie() {
    return (dispatch: AppDispatch, getState: GetRootState) => {
        try {
            const state = getState();
            const controls = state.sketchControls;
            if (controls) {
                if (!controls.cookiePersistenceEnabled) {
                    return;
                }
                const { cookiePersistenceEnabled: _, ...controlsToSave } = controls;
                const jsonString = JSON.stringify(controlsToSave);
                Cookies.set(COOKIE_NAME, jsonString, { expires: COOKIE_EXPIRES_DAYS });
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to save sketch controls to cookie:', error);
        }
    };
}

export function loadSketchControlsFromCookie() {
    return (dispatch: AppDispatch) => {
        try {
            const cookieValue = Cookies.get(COOKIE_NAME);
            if (cookieValue) {
                const data = JSON.parse(cookieValue) as SketchControlsCookieData;
                dispatch(loadFromCookie(data));
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to load sketch controls from cookie:', error);
        }
    };
}
